import React from 'react';
import PropTypes from 'prop-types';
import { Stack, InputAdornment } from '@mui/material';
import { IconButton, TextInput, theme } from 'cprime-foundational-components';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ handleChange = () => {}, handleSearch, placeholder, value }) => {
  return (
    <Stack
      direction="row"
      alignItems="stretch"
      component="form"
      onChange={(e) => {
        e.preventDefault();
        const searchTerm = e.target.value;
        handleChange(searchTerm);
      }}
      onSubmit={(e) => {
        e.preventDefault();
        const searchTerm = e.target.elements[0].value;
        handleSearch(searchTerm);
      }}
      id="SearchBarForm"
    >
      <TextInput
        value={value}
        variant="outlined"
        width="auto"
        placeholder={placeholder}
        size="small"
        InputProps={{
          style: {
            height: '40px',
            paddingRight: '3px',
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" type="submit" sx={{ mr: 1.5 }}>
                <SearchIcon fontSize="small" sx={{ color: theme.colors.secondary[60] }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{ '& .MuiInputBase-input': { lineHeight: '1.25rem !important' } }}
      />
    </Stack>
  );
};

SearchBar.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default SearchBar;
